import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon viewBox="0 0 24 24" boxSize="24px" fill="none" {...props}>
      <mask id="path-1-inside-1_2883_8606" fill="white">
        <path d="M21 13H15V18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18V13Z"></path>
      </mask>
      <path
        d="M21 13V11H23V13H21ZM15 13H13V11H15V13ZM21 15H15V11H21V15ZM17 13V18H13V13H17ZM19 18V13H23V18H19ZM18 19C18.5523 19 19 18.5523 19 18H23C23 20.7614 20.7614 23 18 23V19ZM17 18C17 18.5523 17.4477 19 18 19V23C15.2386 23 13 20.7614 13 18H17Z"
        fill="#FFFFFF"
        mask="url(#path-1-inside-1_2883_8606)"
      ></path>
      <mask id="path-3-inside-2_2883_8606" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3C3.44772 3 3 3.44772 3 4V18C3 19.6569 4.34315 21 6 21L16.8125 21H18.9375C17.905 21 17.2847 20.4623 17 19.6106V4C17 3.44772 16.5523 3 16 3H4Z"
        ></path>
      </mask>
      <path
        d="M6 21L6 19H6V21ZM16.8125 21L16.8125 23H16.8125V21ZM17 19.6106H15V19.936L15.1032 20.2447L17 19.6106ZM5 4C5 4.55228 4.55229 5 4 5V1C2.34314 1 1 2.34315 1 4H5ZM5 18V4H1V18H5ZM6 19C5.44772 19 5 18.5523 5 18H1C1 20.7614 3.23858 23 6 23V19ZM16.8125 19L6 19L6 23L16.8125 23L16.8125 19ZM16.8125 23H18.9375V19H16.8125V23ZM18.9375 19C18.8531 19 18.8208 18.9891 18.8255 18.9906C18.8276 18.9912 18.8363 18.9941 18.8495 19.0008C18.8627 19.0075 18.8773 19.0164 18.8918 19.0273C18.9063 19.0382 18.9178 19.049 18.9263 19.058C18.9346 19.0669 18.9381 19.0722 18.9378 19.0718C18.937 19.0704 18.9192 19.0434 18.8968 18.9765L15.1032 20.2447C15.3437 20.9643 15.7735 21.6861 16.4848 22.222C17.206 22.7655 18.0609 23 18.9375 23V19ZM15 4V19.6106H19V4H15ZM16 5C15.4477 5 15 4.55229 15 4H19C19 2.34314 17.6569 1 16 1V5ZM4 5H16V1H4V5Z"
        fill="#FFFFFF"
        mask="url(#path-3-inside-2_2883_8606)"
      ></path>
      <path
        d="M8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10V8ZM10 10C10.5523 10 11 9.55228 11 9C11 8.44772 10.5523 8 10 8V10ZM8 10H10V8H8V10Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13V11ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11V13ZM8 13H12V11H8V13Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16V14ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM8 16H11V14H8V16Z"
        fill="#FFFFFF"
      ></path>
    </Icon>
  )
}

export default IconComp
